import React from "react";

// DSS wordmark inspired by the brochure logo (white text + gold slash accent)
export default function Logo({ className = "", variant = "light" }) {
  const text = variant === "light" ? "text-white" : "text-navy";
  const sub = variant === "light" ? "text-white/70" : "text-navy/70";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="dss-logo">
      <div className="flex items-baseline">
        <span className={`font-display font-extrabold tracking-tight text-2xl ${text}`}>
          DSS
        </span>
        <span className="ml-0.5 inline-block w-[10px] h-[22px] bg-gold -skew-x-[20deg] translate-y-[2px]" aria-hidden />
      </div>
      <div className="hidden sm:flex flex-col leading-[1.05]">
        <span className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${text}`}>Dynamic</span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${text}`}>Strategic</span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${sub}`}>Solutions</span>
      </div>
    </div>
  );
}
